import type { Action } from './actions'

export type State = {
    sendFormSuccess: ?boolean,
    sendFormError: ?any,
    available: ?boolean,
    error: ?any,
    date: ?string,
    startDate: ?string,
    endDate: ?string,
    networkError?: any
}

const initialState: State = {
    sendFormSuccess: false,
    sendFormError: null,
    available: true,
    error: null,
    startDate: '2021-01-01',
    endDate: '2029-12-31',
    date: '',
    networkError: null
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'FUTURE_WHOPPER_SEND_FORM_SUCCESS':
            return {
                ...state,
                sendFormSuccess: true,
                sendFormError: null,
                date: action.date
            }
        case 'FUTURE_WHOPPER_SEND_FORM_ERROR':
            return {
                ...state,
                sendFormSuccess: false,
                sendFormError: action.error
            }
        case 'FUTURE_WHOPPER_RESET_SEND_FORM_SUCCESS':
            return {
                ...state,
                sendFormSuccess: false,
                sendFormError: null
            }
        case 'PAGE_DATA_FUTURE_WHOPPER_RESPONSE':
            return {
                ...state,
                ...action.data,
                error: null
            }
        case 'PAGE_DATA_FUTURE_WHOPPER_ERROR':
            return {
                ...state,
                available: false,
                error: action.error
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
